"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4728],{

/***/ 64728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8701);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30719);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64384);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  @media screen and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  .swiper {\n    padding-bottom: 50px;\n  }\n  .swiper-scrollbar-horizontal {\n    display: flex;\n    align-items: center;\n    height: 3px;\n    width: 80%;\n    left: 0;\n    bottom: 12px;\n  }\n  @media screen and (max-width: 430px) {\n    .swiper-pagination-fraction {\n      font-size: 12px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  left: 80%;\n  width: 20%;\n  bottom: 0px;\n  padding: 0px 5px;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n  z-index: 30;\n  & span {\n    cursor: pointer;\n    :hover {\n      color: #3bb77e;\n    }\n  }\n  color: #000000;\n  @media screen and (max-width: 430px) {\n    font-size: 26px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 20px;\n  @media screen and (max-width: 768px) {\n    gap: 25px;\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media screen and (max-width: 575px) {\n    gap: 10px;\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 15px;\n  margin-bottom: 25px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 20px 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: none;\n  border-radius: 10px;\n  background-color: ",
        ";\n\n  .title {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    line-height: normal;\n    text-align: start;\n    color: ",
        ";\n    & .question {\n      font-size: 14px;\n    }\n    & h6 {\n      font-size: 20px;\n      font-weight: 600;\n      font-style: normal;\n      color: ",
        ";\n    }\n    .m_title {\n      display: none;\n      & h6 {\n        margin-bottom: 3px;\n      }\n    }\n  }\n  .icon {\n    font-size: 40px;\n    line-height: normal;\n    color: ",
        ";\n    & i {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  @media screen and (max-width: 991px) {\n    padding: 20px 20px;\n    .title {\n      & .question {\n        font-size: 12px;\n      }\n      & h6 {\n        font-size: 18px;\n      }\n    }\n    .icon {\n      font-size: 2rem;\n    }\n  }\n  @media screen and (max-width: 768px) {\n    padding: 20px;\n    .title {\n      & .question {\n        font-size: 10px;\n      }\n      & h6 {\n        font-size: 16px;\n      }\n    }\n    .icon {\n      font-size: 28px;\n      display: none;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    padding: 15px;\n    .title {\n      & .question {\n        display: none;\n      }\n      & h6 {\n        font-size: 16px;\n      }\n      .pc_title {\n        display: none;\n      }\n      .m_title {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n    .icon {\n      font-size: 28px;\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n\n  & figure {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    border-radius: 20px;\n    background-color: #f4f4f4;\n    padding: 10px;\n    border: ",
        ";\n\n    @media screen and (min-width: 1200px) {\n      width: 115px;\n      height: 115px;\n    }\n    @media screen and (max-width: 768px) {\n      min-width: 58px;\n      min-height: 58px;\n      max-width: 65px;\n      max-height: 65px;\n      border-radius: 15px;\n    }\n    @media screen and (max-width: 430px) {\n      width: 45px;\n      height: 45px;\n      border-radius: 15px;\n    }\n  }\n  & img {\n    width: 100%;\n  }\n  :hover {\n    & span {\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  word-break: keep-all;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: wrap;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  @media screen and (max-width: 768px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  top: 25%;\n  left: -40px;\n  width: calc(100% + 80px);\n\n  & span {\n    top: 25%;\n    position: absolute;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100%;\n    box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);\n    background-color: #fff;\n    color: #5a5a5a;\n    font-size: 19px;\n    cursor: pointer;\n    z-index: 9;\n    :hover {\n      background-color: #3bb77e;\n      color: #fff;\n    }\n  }\n  .custom_next_ct1 {\n    right: 0;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}







// 카테고리 개별 구분
var CateogryMobileWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-0"
})(_templateObject());
var CategoryMobile = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-1"
})(_templateObject1());
var MobileSliderArrows = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-2"
})(_templateObject2());
var CategoryGrid = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-3"
})(_templateObject3());
var CategoryType = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-4"
})(_templateObject4());
var TypeBtn = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6ff471f3-5"
})(_templateObject5(), function(props) {
    return props.categoryType ? "#3bb77e" : "#f1f1f1";
}, function(props) {
    return props.categoryType ? "#fff" : "#565656";
}, function(props) {
    return props.categoryType ? "#fff" : "#565656";
}, function(props) {
    return props.categoryType ? "#fff" : "#565656";
});
var CategoryListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-6"
})(_templateObject6());
var CategoryList = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-7"
})(_templateObject7());
var CategoryBox = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-8"
})(_templateObject8(), function(props) {
    return props.active ? "3px solid #3bb77e" : "none";
});
var CategorySliderName = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-6ff471f3-9"
})(_templateObject9());
var SlideArrows = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff471f3-10"
})(_templateObject10());
swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Scrollbar */ .LW,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Grid */ .rj
]);
var CategorySlider = function(param) {
    var dummyList = param.dummyList;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), category1 = ref3[0], setCategory = ref3[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("S"), categoryType = ref1[0], setCategoryType = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), pcSwiper = ref2[0], setPcSwiper = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var ref;
        if (!(dummyList === null || dummyList === void 0 ? void 0 : dummyList.category) || !router.isReady) return;
        // slug가 있거나 경로가 /products/[ename]인 경우 ename 추출
        var enameFromUrl = router.query.slug || ((ref = router.asPath.split("/products/")[1]) === null || ref === void 0 ? void 0 : ref.split("/")[0]);
        var matchedCategory = dummyList.category.find(function(cat) {
            return cat.ename === enameFromUrl;
        });
        if (matchedCategory && matchedCategory.division) {
            setCategoryType(matchedCategory.division);
            localStorage.setItem("categoryType", matchedCategory.division);
        }
    }, [
        router.isReady,
        router.query.slug,
        dummyList === null || dummyList === void 0 ? void 0 : dummyList.category
    ]);
    // 현재 선택된 카테고리 코드를 가져오는 함수
    var getCurrentCategoryCode = function() {
        if (router.query.code) {
            return router.query.code;
        }
        // URL이 /products/[slug] 형태인 경우 slug로 코드 찾기
        if (router.query.slug && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.category)) {
            var matchedCategory = dummyList.category.find(function(cat) {
                return cat.ename === router.query.slug;
            });
            if (matchedCategory) {
                return matchedCategory.code;
            }
        }
        return null;
    };
    var handleCategoryType = function(type) {
        setCategoryType(type);
        localStorage.setItem("categoryType", type);
    };
    var selectCategory = function(e, category) {
        if (category.code === "custom") {
            router.push("/customizing/customizing-products/");
            return;
        }
        e.preventDefault();
        // 새로운 URL 구조 사용
        if (category.ename) {
            router.push("/products/".concat(category.ename, "/"));
        }
        // 타입 정보는 로컬 스토리지에 저장
        localStorage.setItem("categoryType", categoryType);
    };
    var fetchCategory = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setCategory([
                            {
                                code: "custom",
                                name: "\uB9DE\uCDA4\uC81C\uC791",
                                image: "https://file.caretbio.com/caretbio/6d02e18cf31baf6a36c451db02e27461.png"
                            }, 
                        ].concat(_toConsumableArray((ref = dummyList.category) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
                            return categoryType === "T" ? el.division === "T" : el.division === "S";
                        }))));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    // 컴포넌트 마운트 시 로컬 스토리지에서 타입 정보 가져오기
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var savedType = localStorage.getItem("categoryType");
        if (savedType) {
            setCategoryType(savedType);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (dummyList.category) {
            fetchCategory();
        }
    }, [
        dummyList,
        categoryType
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (router.query.type) {
            setCategoryType(router.query.type);
            localStorage.setItem("categoryType", router.query.type);
        }
    }, [
        router.query
    ]);
    // 현재 선택된 카테고리 코드
    var currentCategoryCode = getCurrentCategoryCode();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: category1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                !router.pathname.includes("products") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CateogryMobileWrapper, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryType, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TypeBtn, {
                                    categoryType: !categoryType || categoryType === "S",
                                    value: "S",
                                    onClick: function(e) {
                                        return handleCategoryType("S");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "title",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: "question",
                                                    children: "\uC6D0\uD558\uC2DC\uB294 \uD3EC\uC7A5\uC7AC\uAC00 \uC788\uC73C\uC2E0\uAC00\uC694?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                    className: "pc_title",
                                                    children: "\uD3EC\uC7A5\uC7AC \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "m_title",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                            children: "\uD3EC\uC7A5\uC7AC"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            children: "\uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                className: "fi-rs-check-circle"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TypeBtn, {
                                    categoryType: categoryType === "T",
                                    value: "T",
                                    onClick: function(e) {
                                        return handleCategoryType("T");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "title",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: "question",
                                                    children: "\uC5B4\uB5A4 \uD3EC\uC7A5\uC7AC\uB97C \uACE8\uB77C\uC57C \uB420\uC9C0 \uC5B4\uB824\uC6B0\uC2E0\uAC00\uC694?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                    className: "pc_title",
                                                    children: "\uD3EC\uC7A5 \uD560 \uC0C1\uD488\uC744 \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "m_title",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                            children: "\uD3EC\uC7A5 \uD560 \uC0C1\uD488"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            children: "\uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                className: "fi-rs-check-circle"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategoryMobile, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                                navigation: {
                                    prevEl: ".custom_prev_mc",
                                    nextEl: ".custom_next_mc"
                                },
                                className: "",
                                spaceBetween: 30,
                                slidesPerView: 1,
                                initialSlide: 0,
                                scrollbar: {
                                    hide: false
                                },
                                children: [
                                    category1 && category1.length > 0 && new Array(Math.ceil(category1.length / 8)).fill("").map(function(_, idx) {
                                        return idx + 1;
                                    }).map(function(el, gridIdx) {
                                        var ref;
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategoryGrid, {
                                                children: (ref = category1.slice(el * 8 - 8, el * 8)) === null || ref === void 0 ? void 0 : ref.map(function(item, i) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryBox, {
                                                        onClick: function(e) {
                                                            return selectCategory(e, item);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figure", {
                                                                className: "",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                                    src: item.image,
                                                                    alt: ""
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategorySliderName, {
                                                                    children: item.name
                                                                })
                                                            })
                                                        ]
                                                    }, i);
                                                })
                                            })
                                        }, gridIdx);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MobileSliderArrows, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: "custom_prev_mc",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                    className: "fi-rs-arrow-small-left"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: "custom_next_mc",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                    className: "fi-rs-arrow-small-right"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryListWrapper, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryType, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TypeBtn, {
                                    categoryType: !categoryType || categoryType === "S",
                                    value: "S",
                                    onClick: function(e) {
                                        return handleCategoryType("S");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "title",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: "\uC6D0\uD558\uC2DC\uB294 \uD3EC\uC7A5\uC7AC\uAC00 \uC788\uC73C\uC2E0\uAC00\uC694?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                    children: "\uD3EC\uC7A5\uC7AC \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                className: "fi-rs-check-circle"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TypeBtn, {
                                    categoryType: categoryType === "T",
                                    value: "T",
                                    onClick: function(e) {
                                        return handleCategoryType("T");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "title",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: "\uC5B4\uB5A4 \uD3EC\uC7A5\uC7AC\uB97C \uACE8\uB77C\uC57C \uB420\uC9C0 \uC5B4\uB824\uC6B0\uC2E0\uAC00\uC694?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                    children: "\uD3EC\uC7A5 \uD560 \uC0C1\uD488\uC744 \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                className: "fi-rs-check-circle"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryList, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                                    navigation: {
                                        prevEl: ".custom_prev_ct1",
                                        nextEl: ".custom_next_ct1"
                                    },
                                    className: "",
                                    centeredSlides: false,
                                    spaceBetween: 30,
                                    slidesPerView: 8,
                                    slidesPerGroupSkip: 0,
                                    breakpoints: {
                                        768: {
                                            slidesPerView: 8,
                                            slidesPerGroup: 8
                                        }
                                    },
                                    grabCursor: true,
                                    initialSlide: 0,
                                    onSwiper: setPcSwiper,
                                    onSlideChange: function(swiper) {
                                        return setPcSwiper(_objectSpread({}, pcSwiper, {
                                            realIndex: swiper.realIndex
                                        }));
                                    },
                                    children: category1 === null || category1 === void 0 ? void 0 : category1.map(function(item, i) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryBox, {
                                                onClick: function(e) {
                                                    return selectCategory(e, item);
                                                },
                                                active: currentCategoryCode === item.code,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figure", {
                                                        className: "",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                            src: item.image,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategorySliderName, {
                                                            children: item.name
                                                        })
                                                    })
                                                ]
                                            })
                                        }, i);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlideArrows, {
                                    className: "slider-arrow",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "custom_prev_ct1",
                                            style: {
                                                visibility: pcSwiper && (pcSwiper === null || pcSwiper === void 0 ? void 0 : pcSwiper.realIndex) == 0 ? "hidden" : "visible"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                className: "fi-rs-angle-left"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "custom_next_ct1",
                                            style: {
                                                visibility: pcSwiper && (pcSwiper === null || pcSwiper === void 0 ? void 0 : pcSwiper.realIndex) + 8 >= (category1 === null || category1 === void 0 ? void 0 : category1.length) ? "hidden" : "visible"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                className: "fi-rs-angle-right"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .connect */ .$j)(mapStateToProps, null)(CategorySlider));


/***/ })

}]);